import { PropsWithChildren } from 'react'
import { Typography } from '@mui/material'
import styled from '@emotion/styled'
import { Colors } from 'src/components/theme'

const Title = styled(Typography)`
  font-family: inherit;
`

const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 8px;
`

type SidebarResultOverlayContainerProps = PropsWithChildren<{
  title: string
}>
export const SidebarResultOverlayContainer: React.FC<SidebarResultOverlayContainerProps> = ({ title, children }) => {
  return (
    <Container>
      <Title color={Colors.neutral400} fontSize={14}>
        {title}
      </Title>
      {children}
    </Container>
  )
}
